import styles from "./Postcard_Reusable.module.css";

import gallery_icon from "../../../assets/images/icons/gallery_ace.svg";

import { Helmet } from "react-helmet";

import React, { useState } from "react";

import edit_1 from "../../../assets/images/edit_screen/PrintQuarterSize/edit_1.png";
import edit_2 from "../../../assets/images/edit_screen/PrintQuarterSize/edit_2.png";
import edit_3 from "../../../assets/images/edit_screen/PrintQuarterSize/edit_3.png";
import edit_4 from "../../../assets/images/edit_screen/PrintQuarterSize/edit_4.png";
import EditScreenSelector from "../../Reusables/EditScreenSelector";
import { Link, scroller } from "react-scroll";

const PostcardReusable = React.forwardRef(
  (
    {
      index,
      callback,
      callbackPreviewChange,
      state,
      image_selection_popup,
      setShowModal,
      //new stuff
      saveThisProduct,
      changeCopyDetails,
      selectedCopyDetails,
      currentPageNumber,
      totalPageNumber,
      confirmEdits,
    },
    ref,
  ) => {
    <Helmet>
      <script>
        {`
   (function(d) {
    var config = {
      kitId: 'tnx5lwp',
      scriptTimeout: 3000,
      async: true
    },
    h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
  })(document);
  `}
      </script>
    </Helmet>;
    const { images } = state;

    const changeState = (key, value) => {
      state[key] = value;
      callback(state);
    };
    const allImagesPicked = () => {
      let current = images.reduce((total, item) => total + item.count, 0);
      if (current < 10) {
        return false;
      }
      return true;
    };
    const imgPickedCount = () => {
      return images.reduce((total, item) => total + item.count, 0);
    };
    const uploadImage = () => {
      image_selection_popup(index, 10 - imgPickedCount());
    };

    const copyOptions = [];
    for (let i = 1; i < currentPageNumber; i++) {
      copyOptions.push(i + "個目と同じ");
    }
    copyOptions.push("別のデザインで作る");
    // let copySelected =
    //   selectedCopyDetails === currentPageNumber
    //     ? currentPageNumber + "個目の写真"
    //     : selectedCopyDetails+"個目の写真";
    let copySelected = selectedCopyDetails + "個目の写真";
    const extractNumber = (s, currentPageNumber, totalPageNumber) => {
      for (let i = totalPageNumber; i > 0; i--) {
        if (s.includes(i)) {
          return i;
        }
      }
      return currentPageNumber;
    };
    return (
      <div className={styles.main_div}>
        <div className={styles.top_hr}></div>
        <div className={styles.header_section_main}>
          {currentPageNumber === 1 && (
            <div name="写真選択" className={styles.header_section}>
              写真選択
            </div>
          )}

          {totalPageNumber > 1 && (
            <div
              className={styles.header_number}
              name={"editsection" + currentPageNumber}
            >
              {currentPageNumber + "個目"}
            </div>
          )}
        </div>
        {currentPageNumber > 1 && (
          <div className={styles.multi_page_selector_wrapper}>
            <div className={styles.multi_page_selector}>
              <EditScreenSelector
                takeupspace={true}
                options={copyOptions}
                callback={(value) => {
                  console.log(value);
                  changeCopyDetails(
                    extractNumber(value, currentPageNumber, totalPageNumber),
                    index,
                  );
                  // changeState("sec03textbox", value);
                  // setSec03textbox(value);
                }}
                selected={copySelected}
              />
            </div>
          </div>
        )}
        {selectedCopyDetails === currentPageNumber && (
          <>
            <div className={styles.edit_title_text_01}>
              写真を選択し、合計10枚となるよう枚数を入力してください。
            </div>
            <div className={styles.edit_title_text_001}>
              同じ写真を複数枚セレクトすることも、10枚別の写真をセレクトすることも可能です。
            </div>
            <div
              onClick={(event) => {
                console.log(allImagesPicked());
                if (allImagesPicked()) return;
                // setImageArray(...imgArray, {
                //   count: 1,
                //   src: sampleArray[Math.floor(Math.random() * sampleArray.length)],
                // });
                uploadImage();
              }}
              className={styles.upload_image_placeholder}
            >
              <img
                className={styles.upload_image_gallery_icon}
                src={gallery_icon}
                alt="top_gallery"
              />

              <div className={styles.upload_image_placeholder_text}>
                写真選択
              </div>
            </div>
            <div className={styles.spacing01}></div>
            <div className={styles.hr001}></div>
            <div className={styles.spacing01}></div>
            <div className={styles.image_container_main}>
              {Array.isArray(images) &&
                images.length > 0 &&
                images.map((item, index) => {
                  if (item.src === "" || item.count === 0) return null;
                  return (
                    <div className={styles.image_single_container} key={index}>
                      <div className={styles.image_main_div}>
                        <img
                          src={item.src}
                          className={styles.edit_image}
                          alt="edit img"
                        />
                        <div
                          onClick={() => {
                            console.log("Cross the image");

                            let temp = JSON.parse(JSON.stringify(images));
                            temp[index].count = 0;
                            temp[index].src = "";
                            changeState("images", temp);
                            // setImageArray(imgArray.filter((item, i) => index !== i));
                          }}
                          className={styles.cross_div}
                        >
                          <ion-icon
                            className={styles.cross_icon}
                            name="close"
                          ></ion-icon>
                        </div>
                      </div>
                      <div className={styles.single_count_section_main}>
                        <div
                          onClick={() => {
                            if (images[index]["count"] <= 1) return;
                            let temp = JSON.parse(JSON.stringify(images));
                            temp[index]["count"] -= 1;
                            changeState("images", temp);
                          }}
                          className={styles.minus_div}
                        >
                          _
                        </div>
                        <div className={styles.number_div}>{item.count}</div>
                        <div
                          onClick={() => {
                            if (allImagesPicked()) return;
                            let temp = JSON.parse(JSON.stringify(images));
                            temp[index]["count"] += 1;
                            changeState("images", temp);
                          }}
                          className={styles.plus_div}
                        >
                          +
                        </div>
                        <div className={styles.number_text}>枚</div>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className={styles.images_picked_main_div}>
              現在、合計枚数は
              <div className={styles.image_picked_number}>
                {imgPickedCount()}
              </div>
              枚です。
            </div>
          </>
        )}
        <div className={styles.confirm_edits_wrapper}>
          <div className={styles.confirm_edits}>
            <div className={styles.confirm_header}>
              上記の内容でデザイン決定しますか？
            </div>
            <div className={styles.confirm_button_section}>
              <Link
                to={
                  totalPageNumber === 1
                    ? "情報入力"
                    : "editsection" + currentPageNumber
                }
                spy={true}
                smooth={true}
                offset={-100}
                duration={500}
              >
                <button className={styles.confirm_button_no}>編集へ戻る</button>
              </Link>
              <button
                onClick={() => {
                  if (!allImagesPicked()) {
                    setShowModal(true);
                    return;
                  }
                  if (totalPageNumber === 1) {
                    confirmEdits();
                  } else {
                    if (currentPageNumber < totalPageNumber) {
                      const elementName =
                        "editsection" + (currentPageNumber + 1);

                      scroller.scrollTo(elementName, {
                        spy: true,
                        smooth: true,
                        offset: -100,
                        duration: 500,
                      });
                    } else {
                      confirmEdits();
                    }
                  }
                }}
                className={styles.confirm_button_yes}
              >
                はい
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  },
);

export default PostcardReusable;
